import { render, staticRenderFns } from "./COMparticulars.vue?vue&type=template&id=1295f523&scoped=true"
import script from "./COMparticulars.vue?vue&type=script&lang=js"
export * from "./COMparticulars.vue?vue&type=script&lang=js"
import style0 from "./COMparticulars.vue?vue&type=style&index=0&id=1295f523&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1295f523",
  null
  
)

export default component.exports